<template>
    <div class="exam-detail">
        <div class="evaluation-top">
            <div class="evaluation-top-title">测评考试</div>
            <div class="evaluation-top-desc">提高文明素质 严肃考风考纪</div>
        </div>
        <div class="exam-content">
            <div class="exam-title">
                <span>{{ examInfo.title }}</span>
                <!-- <span>理疗师考试</span> -->
            </div>
            <!-- 考试须知 -->
            <div class="exam-notice">
                <div class="notice-header">
                    <van-icon name="volume-o" color="#fff" size="20" />
                    <span class="notice-title">考试须知</span>
                </div>

                <div class="notice-list">
                    <!-- <div class="notice-item" v-for="(item, index) in noticeList" :key="index">
                        <div class="notice-number">{{ String(index + 1).padStart(2, '0') }}</div>
                        <div class="notice-content">{{ item }}</div>
                    </div> -->
                    <div class="notice-content" v-html="notice"></div>
                </div>

                <!-- 已阅读确认 -->
                <div class="read-confirm">
                    <van-checkbox v-model="hasRead" icon-size="18px">
                        已阅读知晓考试须知
                    </van-checkbox>
                </div>

                <!-- 进入考试按钮 -->
                <div class="start-exam-btn">
                    <van-button type="warning" round block :disabled="!hasRead" @click="startExam">
                        进入考试 ►
                    </van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { startQuiz } from '@/api/index.js';
import examBkPay201Mixin from '@/mixins/exam-bk-pay-201.js';

export default {
    name: 'ExamDetail',
    mixins: [examBkPay201Mixin],
    data() {
        return {
            examInfo: {
                id: '',
                title: ''
            },
            hasRead: false,
            notice: '',
            noticeList: [
                '考生应自觉遵守各项考试纪律，诚信应考。',
                '本次考试采用在线全程闭卷形式，为保证考生考试顺利进行，相关考试环境设备要求请考生仔细阅读《线上双摄网考操作手册及常见问题解决办法》和《线上双摄网考环境要求》，严格按照要求准备考试相关设备并保持电量充足，全程使用外接电源。',
                '考生须携带本人准考证（登录中国研究生招生信息网http://yz.chsi.cn或http://yz.chsi.com.cn下载打印）和有效居民身份证参加考试。《准考证》使用A4白纸打印，正、反两面在使用期间不得涂改或书写。证件不齐或信息不符者，一律不准进入考场。',
                '考生如携带饮用水进入考场，需确保水杯或水瓶为透明材质，且瓶身标签必须完除。'
            ]
        };
    },
    created() {
        // 获取路由参数
        this.examInfo.id = this.$route.query.id || '';
        this.examInfo.title = this.$route.query.title || '考试详情';
        // 从 Vuex 获取 notice
        this.notice = this.$store.state.examNotice || '';
    },
    methods: {
        startExam() {
            if (!this.hasRead) {
                this.$toast('请先阅读并确认考试须知');
                return;
            }
            
            if (!this.examInfo.id) {
                this.$toast.fail('试卷ID不存在');
                return;
            }
            
            this.runStartQuiz();
        },
        getTestPaperIdForOrder() {
            const n = Number(this.examInfo.id);
            return Number.isFinite(n) ? n : 0;
        },
        /** 已达免费次数：创建补考订单并拉起 JSAPI 支付 */
        handleFreeExamLimitPayment(err) {
            this.handleBkPayAfter201(err, {
                testPaperId: this.getTestPaperIdForOrder(),
                onPaid: () => {
                    this.runStartQuiz();
                },
            });
        },
        runStartQuiz() {
            this.$toast.loading({
                message: '开始考试...',
                forbidClick: true,
            });

            startQuiz(this.examInfo.id)
                .then((res) => {
                    this.$toast.clear();

                    if (res.data && res.data.answerId && res.data.remainingTotalSeconds) {
                        const { answerId, remainingTotalSeconds } = res.data;

                        const remainingMinutes = Math.ceil(remainingTotalSeconds / 60);
                        this.$store.commit('setExamDuration', remainingMinutes);

                        const now = Date.now();
                        const totalSeconds = remainingMinutes * 60;
                        const elapsedSeconds = totalSeconds - remainingTotalSeconds;
                        const startTime = now - elapsedSeconds * 1000;
                        this.$store.commit('setExamStartTime', startTime);

                        this.$toast.success('开始考试');

                        this.$router.push({
                            path: '/exam-paper',
                            query: {
                                id: answerId,
                                testPaperId: this.examInfo.id,
                            },
                        });
                    } else {
                        this.$toast.fail('返回数据格式错误');
                    }
                })
                .catch((err) => {
                    if (err && err.code == 201) {
                        this.handleFreeExamLimitPayment(err);
                        return;
                    }
                    this.$toast.clear();
                });
        }
    }
};
</script>

<style scoped lang='scss'>
.exam-detail {
    box-sizing: border-box;
    min-height: 100%;
    background: linear-gradient(to bottom, #C2E5EB, #EEF4F5);
    padding-bottom: 20px;
}

.evaluation-top {
    box-sizing: border-box;
    padding-top: 90px;
    padding-left: 15px;
    width: 100%;
    height: 300px;
    background: url('~@/assets/image/evaluation-top-bg.png') no-repeat center center;
    background-size: 100% 100%;

    .evaluation-top-title {
        font-size: 24px;
        font-weight: bold;
        color: #fff;
    }

    .evaluation-top-desc {
        font-size: 15px;
        color: #fff;
    }
}

.exam-content {
    padding: 30px 16px;
    margin-top: -80px;
    position: relative;
    z-index: 2;
    background: linear-gradient(to bottom, #C2E5EB, #EEF4F5);
    border-radius: 20px 20px 0 0;

    .exam-title {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 22px;
        color: #333;
    }

    .exam-notice {
        margin-top: 40px;
        position: relative;
        padding: 15px;
        border-radius: 10px;
        background: #fff;

        .notice-header {
            position: absolute;
            top: -20px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            width: 133px;
            height: 34px;
            background: url('~@/assets/image/evaluation-notice-bg.png') no-repeat center center;
            background-size: 100% 100%;

            .notice-title {
                margin-left: 5px;
                color: #fff;
                font-size: 15px;
            }
        }

        .notice-list {
            margin-top: 30px;

            .notice-item {
                display: flex;
                margin-bottom: 14px;

                &:last-child {
                    margin-bottom: 0;
                }

                .notice-number {
                    flex-shrink: 0;
                    width: 18px;
                    height: 18px;
                    background: #EDF9FB;
                    color: #4DC8D9;
                    border-radius: 2px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                }

                .notice-content {
                    margin-left: 10px;
                    flex: 1;
                    font-size: 12px;
                    color: #666666;
                }
            }
        }

        .read-confirm {
            margin-top: 20px;
            display: flex;
            justify-content: center;

            ::v-deep .van-checkbox__label {
                color: #333333;
                font-size: 14px;
            }
        }

        .start-exam-btn {
            margin-top: 30px;
            padding: 0 20px;

            .van-button {
                height: 46px;
                font-size: 16px;
                font-weight: bold;
                background: #FF6633;
                border: none;

                &--disabled {
                    background: #ddd;
                }
            }
        }

    }
}
</style>
